export const onFormatterAccountNo = (value) => {
	if (valueValidation(value, true)) return value;
	value = value.replace(/\D/g, "");
	value = value.match(/.{1,4}/g);
	return value.join(" ");
};

export const onFormatterNo = (number, decimal_place = 2) => {
	if (valueValidation(number)) number = 0;
	if (/,/.test(number)) {
		number = number.replaceAll(",", "");
	}

	let num = parseFloat(number);
	const factor = Math.pow(10, decimal_place);
	num = Math.round(num * factor + 1e-12) / factor;

	return new Intl.NumberFormat("en-US", {
		minimumFractionDigits: decimal_place,
		maximumFractionDigits: decimal_place
	}).format(num);

}

export const handleNumberFormat = (data, fields) => {
	for (const [field, decimal_place] of Object.entries(fields)) {
		data[field] = onFormatterNo(data[field], decimal_place);
	}
}

export const onFormatterTrim = (v, limit_length = 0) => {
	if (valueValidation(v)) return "";

	return (limit_length ? v.slice(0, limit_length) : v).toString().trim();
};

export const onFormatterUpperCase = (v, limit_length = 0) => {
	if (valueValidation(v)) return "";

	return (limit_length ? v.slice(0, limit_length).toUpperCase() : v.toUpperCase()).toString().trim();
};

export const onFormatterLowerCase = (v, limit_length = 0) => {
	if (valueValidation(v)) return "";
	return limit_length ? v.slice(0, limit_length).toLowerCase() : v.toLowerCase();
};

export const onFormatterCapitalize = (v) => {
	if (valueValidation(v)) return "";
	v = v.toLowerCase();
	if (/\n/.test(v)) {
		return v
			.split("\n")
			.map((val1) =>
				val1
					.split(" ")
					.map((val) => val.charAt(0).toUpperCase() + val.slice(1))
					.join(" ")
			)
			.join("\n");
	} else {
		return v
			.split(" ")
			.map((val) => val.charAt(0).toUpperCase() + val.slice(1))
			.join(" ");
	}
};

export const formatNull = (value, emptyString = '-') => {
	return valueValidation(value) ? emptyString : value;
}

export const handleNullToString = (data, fields) => {

	fields.forEach(f => {
		data[f] = formatNull(data[f], "");
	})
}

export const valueValidation = (value, include_zero = false) => {
	if (typeof value == "undefined" || value == null) return true;
	if (typeof value === "string" && ((value == null || value == "NaN" || value.toString().trim() == "") || (include_zero && parseFloat(value.toString()) == 0))) return true;
	if (Array.isArray(value)) return value.length === 0;
	if (typeof value === "object") return Object.keys(value).length === 0;
	return false;
}

export const filterAscii = (value) => {
	const regex = /[^A-Za-z0-9 !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/g
	return !valueValidation(value) ? value.replace(regex, "") : value;
}

export const asciiValidation = (value) => {
	// const regex = /[^A-Za-z0-9 !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/;
	const regex = /^[\s\x20-\x7E]*$/;
	return valueValidation(value) ? true : regex.test(value);
}

export const stringLenValidation = (value, len) => {
	return valueValidation(value) ? false : parseInt(value.length) > len;
}

export const filterSelectionByStatus = (selection, value, key = "status", vkey = "id", incl_active = false) => {
	if (valueValidation(selection)) return selection;
	return selection.filter(s => valueValidation(s[key])
		|| (incl_active && parseInt(s[key]) == 0)
		|| ![0, 2].includes(s[key])
		|| (!valueValidation(value) && ((typeof value == 'object' && value.includes(s[vkey])) || (typeof value != 'object' && value == s[vkey]))))
}

export const replaceValue = (value, fields) => {
	if (valueValidation(value)) return "";

	for (let f of fields) {
		const regex = new RegExp(f['key'].replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
		value = value.replace(regex, f['value']);
	}

	return value
}

export const splitStr = (value, separator = ",") => {
	if (valueValidation(value)) return [];
	return value.split(separator);
}

export const stripHTML = (html) => {
	const temp = document.createElement('div');
	temp.innerHTML = html;
	return temp.textContent || temp.innerText || '';
}
